import type { InternalStatusHistoryEntryView } from "@credit-acceptance/step6-bff-client";

/** A single status history entry, normalized for the UI. */
export interface StatusHistoryEntry {
  workqueue: string;
  status: string;
  phase: string;
  user: string;
  endStatus: string;
  endPhase: string;
  startDate: string;
  endDate: string;
}

/**
 * Normalizes a raw BFF response entry into a StatusHistoryEntry.
 * @param raw - A single entry from the BFF response.
 * @returns {StatusHistoryEntry} The normalized entry.
 */
export function toStatusHistoryEntry(raw: InternalStatusHistoryEntryView): StatusHistoryEntry {
  return {
    workqueue: raw.workqueue ?? "",
    status: raw.status ?? "",
    phase: raw.phase ?? "",
    user: raw.user ?? "",
    endStatus: raw.endStatus ?? "",
    endPhase: raw.endPhase ?? "",
    startDate: raw.startDate ?? "",
    endDate: raw.endDate ?? "",
  };
}
